import React from "react";
import { Link } from "react-router-dom";
import { Layout, Dropdown, Menu, Row, Col, Avatar, Button } from "antd";
import { LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import { geturl } from "../../common/api/SafeClient";
import { stopImpersonating } from "../../common/api/AdminDashboardClient";
import { User } from "../../types/UserGroup";
import "./AppHeader.less";

interface AppHeaderProps {
    me: Partial<User>;
    disabled?: boolean;
}

// Only the renewal intake demo still mounts this: the app itself puts its
// logo and account rows in the AppShell sider.
const PREFIX = "AppHeader";

export const AppHeader: React.FC<AppHeaderProps> = ({ me, disabled = false }) => {
    const exitImpersonation = async () => {
        try {
            await stopImpersonating();
        } finally {
            // A full navigation, not a state update: the session user just
            // changed, so every piece of loaded state is stale.
            window.location.assign("/");
        }
    };

    const menu = (
        <Menu onClick={() => {}} mode="horizontal">
            <Menu.Item>Hi{me.firstName ? ` ${me.firstName}` : ""} 👋</Menu.Item>
            <Menu.Item icon={<SettingOutlined />}>
                <Link to="/preferences"> My preferences</Link>
            </Menu.Item>
            <Menu.Item icon={<LogoutOutlined />}>
                <a href={geturl("/api/logout")}>Log out</a>
            </Menu.Item>
        </Menu>
    );

    return (
        <Layout.Header className={`${PREFIX}`}>
            <Row>
                <Col flex={1}>
                    <Link to="/dashboard">
                        <img src="/infinity-loop-logo-horz-color-wt.svg" alt="logo" />
                    </Link>
                </Col>
                {me.impersonating && (
                    <Col className={`${PREFIX}-impersonation`}>
                        Impersonating{" "}
                        {me.impersonating.organizationName ||
                            me.impersonating.organizationDomain}
                        .
                        <Button type="link" size="small" onClick={exitImpersonation}>
                            Exit?
                        </Button>
                    </Col>
                )}
                <Col style={{ display: "inline-flex" }}>
                    <Dropdown overlay={menu}>
                        <Avatar
                            className={`${PREFIX}-avatar`}
                            shape="square"
                            size={64}
                            src={me.avatar || "/base-avatar.png"}
                        ></Avatar>
                    </Dropdown>
                </Col>
            </Row>
        </Layout.Header>
    );
};
